export const generateVacancyLink = (regionId: number, name: string | undefined, id: number | undefined) =>
  `/vacancies-realtors/?region=${regionId}&companyname=${name}#${id}`;
